<!-- Componente referente ao menu registros -> ambiente -> selecionar um resource -->

<template>
	<v-list two-line subheader v-if="value && value.length > 0">
		<v-subheader>Reg Types</v-subheader>
		<div v-for="(regType, i) in value" :key="i">
			<v-list-item @click="$emit('click', regType)">
				<v-list-item-action>
					<v-avatar :color="regType.color" size="36"></v-avatar>
				</v-list-item-action>
				<v-list-item-content>
					<v-list-item-title>{{ regType.description }}</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
			<v-divider></v-divider>
		</div>
	</v-list>
</template>

<script>
	export default {
		name: "reg-type-list",
		props: ["value"],
	};
</script>
